module.exports = __webpack_public_path__ + "static/media/renovation.1dc48b2e.jpeg";